/* Maßfeld auf der Produktseite (snippets/cc-massfeld.liquid), live seit 15.09.2026.
 *
 * Formel wie assets/config-product.js (Klassik Matt) und assets/cc-funnel-danke.js:
 *   raw = BASE + AREA * flaeche^EXP + HCOEFF*H + WCOEFF*W + Stufe ; preis = round(raw) + 0.90
 *   Stufe = Zuschlag je m Breite, wenn die Höhe über der Materialstufe liegt
 *   sale  = preis * (100 - Rabatt) / 100, nur solange die Aktion läuft
 * Alle Formelwerte kommen von der echten Konfigurator-Seite des Motivs. Geholt wird erst,
 * wenn jemand ein Feld antippt; bis dahin steht der serverseitig gerenderte Startpreis.
 * Scheitert der Abruf, bleibt der Preis ausgegraut (lieber keiner als ein falscher).
 */
(function () {
  var box = document.querySelector('[data-cc-massfeld]');
  if (!box) return;

  var hIn = box.querySelector('[data-cc-mf-h]');
  var wIn = box.querySelector('[data-cc-mf-w]');
  var jetztEl = box.querySelector('[data-cc-mf-jetzt]');
  var normalEl = box.querySelector('[data-cc-mf-normal]');
  var fehlerEl = box.querySelector('[data-cc-mf-fehler]');
  var sale = box.getAttribute('data-sale') === 'true';
  var pct = Number(box.getAttribute('data-pct')) || 20;

  // Grenzen wie die Eingabefelder im Konfigurator und dessen Fehlertext
  var MIN_H = 40, MAX_H = 117, MIN_W = 50, MAX_W = 500;

  // Kurzer Cache, damit nicht jede Produktseite die Konfigurator-Seite erneut lädt.
  // 30 Minuten: Ändert Alwin eine Formelzahl, stimmt die Produktseite spätestens danach.
  var CACHE_MS = 30 * 60 * 1000;
  var themeId = (window.Shopify && Shopify.theme && Shopify.theme.id) || '';
  var CACHE_KEY = 'ccPreisformel:' + themeId;

  var formel = null, laedt = false, geaendert = false, fehlerTimer = null;

  function euro(n) { return n.toFixed(2).replace('.', ',') + ' €'; }

  function zahl(input) {
    var n = parseFloat(String(input.value).replace(',', '.'));
    return isFinite(n) ? n : NaN;
  }

  function lesen(html) {
    var attr = function (name, standard) {
      var m = html.match(new RegExp('data-' + name + '="(-?[0-9.]+)"'));
      var n = m ? parseFloat(m[1]) : NaN;
      return isFinite(n) ? n : standard;
    };
    var f = {
      area: attr('klassik-area', NaN),
      base: attr('klassik-base', 6.5),
      exp: attr('klassik-exp', 0.898),
      hcoeff: attr('klassik-hcoeff', 21),
      wcoeff: attr('klassik-wcoeff', -5),
      stufeCm: attr('height-step-cm', 60),
      stufeEur: attr('height-step-surcharge', 1.31)
    };
    return f.area > 0 ? f : null;
  }

  function laden() {
    if (formel || laedt) return;
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (c && c.f && Date.now() - c.t < CACHE_MS) { formel = c.f; rechnen(); return; }
    } catch (e) {}
    laedt = true;
    fetch(box.getAttribute('data-config-url'), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error('http-' + r.status)); })
      .then(function (html) {
        var f = lesen(html);
        if (!f) return;
        formel = f;
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), f: f })); } catch (e) {}
        rechnen();
      })
      .catch(function () {})
      .then(function () { laedt = false; });
  }

  function fehler(zeigen) {
    clearTimeout(fehlerTimer);
    fehlerEl.hidden = !zeigen;
  }

  function rechnen() {
    var h = zahl(hIn), w = zahl(wIn);
    var hOk = h >= MIN_H && h <= MAX_H;
    var wOk = w >= MIN_W && w <= MAX_W;
    hIn.classList.toggle('cc-mf__in--fehler', !hOk);
    wIn.classList.toggle('cc-mf__in--fehler', !wOk);
    if (!hOk || !wOk) {
      box.classList.add('cc-mf--ungueltig');
      return false;
    }
    box.classList.remove('cc-mf--ungueltig');
    fehler(false);
    // Unverändertes Startmaß: der serverseitige Preis stimmt bereits
    if (!geaendert) return true;
    if (!formel) {
      box.classList.add('cc-mf--laedt');
      return true;
    }
    box.classList.remove('cc-mf--laedt');
    var W = w / 100, H = h / 100;
    var stufe = h > formel.stufeCm ? formel.stufeEur * W : 0;
    var raw = formel.base + formel.area * Math.pow(W * H, formel.exp) + formel.hcoeff * H + formel.wcoeff * W + stufe;
    var regulaer = Math.round(raw) + 0.90;
    if (!(regulaer > 0)) return true;
    var eigen = sale ? +(regulaer * (100 - pct) / 100).toFixed(2) : regulaer;
    jetztEl.textContent = euro(eigen);
    if (normalEl) normalEl.textContent = euro(regulaer);
    return true;
  }

  [hIn, wIn].forEach(function (input) {
    input.addEventListener('focus', laden);
    input.addEventListener('pointerdown', laden);
    input.addEventListener('input', function () {
      geaendert = true;
      laden();
      clearTimeout(fehlerTimer);
      // Während des Tippens (z. B. „1" auf dem Weg zu „117") nicht sofort warnen
      if (!rechnen()) fehlerTimer = setTimeout(function () { if (!rechnen()) fehler(true); }, 1200);
    });
    input.addEventListener('change', function () { if (!rechnen()) fehler(true); });
    input.addEventListener('blur', function () { if (!rechnen()) fehler(true); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') input.blur(); });
  });
})();
